import { Component, OnInit, Output, EventEmitter, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import to from 'await-to-js';
import { IBook, IUser } from '../../types/datatypes';

import { UserService } from '../../core/services/data/user.service';
import { AuthorService } from '../../core/services/data/author.service';

@Component({
	selector: 'app-book-shelf-search',
	templateUrl: './book-shelf-search.component.html',
	styleUrls: ['./book-shelf-search.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class BookShelfSearchComponent implements OnInit, OnDestroy {
	@Output() bookSelected = new EventEmitter<IBook>();

	@Output() closeBookShelfSearch = new EventEmitter<any>();

	public form: UntypedFormGroup;

	public filteredBooks;

	public showBookSearch = false;

	public defaultImageUrl = '../../../assets/img/defaults/default_book_image_400w_simple.jpg';

	public books;

	public _books;

	public author: IUser;

	public loading = true;

	public $author;

	public $bookStore;

	constructor(
		public userService: UserService,
		private authorService: AuthorService,
	) { }

	ngOnInit(): void {
		this.$author = this.userService.author$.subscribe((author: IUser) => {
			this.author = author;
			this.getAuthorBooks();
		});

		this.form = new UntypedFormGroup({
			book: new UntypedFormControl(),
		});
	}

	ngOnDestroy(): void {
		this.$author.unsubscribe();
	}

	async getAuthorBooks(): Promise<void> {
		const body = {
			authorId: this.author._id,
		};
		const [err, books] = await to(this.authorService.authorBooks(body));
		if (Array.isArray(books)) {
			this._books = [];

			for (const book of books) {
				this._books.push({ ...book });
			}
		}
		//eslint-disable-next-line no-console
		if (err) { console.log(err); }
		this.books = books;
		this.filteredBooks = books;
		this.loading = false;
	}

	searchBooks(): void {
		const query = this.form.get('book').value;

		if (!query?.length) {
			this.showBookSearch = false;
			return;
		}

		this.showBookSearch = true;
		this.filteredBooks = this.books.filter((book) => book.title).filter((book) => book.title.toLowerCase().includes(query.toLowerCase()));
	}

	selectBook(book: IBook): void {
		const bookSelected = this._books.find((b) => b._id === book._id);
		this.bookSelected.emit({ ...bookSelected });
	}
}
